export class Navigation {
  static home (): string {
    return '/'
  }

  static selectCharityCauses (): string {
    return '/donation/charity-causes'
  }

  static donationSplit (): string {
    return '/donation/donation-split'
  }

  static extras (): string {
    return '/donation/extras'
  }

  static qurbani (): string {
    return '/donation/qurbani'
  }

  static payment (): string {
    return '/donation/payment'
  }

  static confirmation (): string {
    return '/share'
  }

  static accountSchedules (): string {
    return '/account/schedules'
  }
}
